import utils from './utils';

/**
 * The first tag rule whose pattern occurs in a transaction title, or null.
 *
 * Matching is deliberately dumb -- case- and diacritic-insensitive substring
 * containment, first rule wins. No regex: the same match has to be reproducible
 * in Python when the import starts applying these server-side, and plain
 * containment is the only thing guaranteed not to drift between the two. See
 * normalize_text in backend/core/utils.py.
 *
 * `rules` is state.TagRules.list, which /api/tag_rules/get_options/ already
 * returned filtered to is_active and ordered by (priority, id) -- so array
 * order IS priority order. Do not re-sort here.
 *
 * Pure, and in its own module rather than beside the drawer, so the contract can
 * be unit-tested without a store (same reasoning as repeatExpiryText.js).
 */
export const matchTagRule = (title, rules = []) => {
  const haystack = utils.normalizeText(title);
  if (!haystack) return null;

  return (
    rules.find((rule) => {
      // pattern_normalized comes straight from the server, so the PATTERN side
      // is never normalized here -- only the title. That halves the surface on
      // which the JS and Python folds could disagree. The fallback only matters
      // for a rule object assembled client-side.
      const needle = rule.pattern_normalized || utils.normalizeText(rule.pattern);
      return needle && haystack.includes(needle);
    }) || null
  );
};

export default matchTagRule;
